<div>
    <mmoga-organization-relocation *ngIf="showOrganizationRelocationModal"
                                   [showModal]=showOrganizationRelocationModal
                                   [currentEnterpriseId]="editedGroupId"
                                   [organizationDto]="relocatingOrganization"
                                   (isOrganizationRelocating)=handleOrganizationRelocation($event)>
    </mmoga-organization-relocation>
    <form [formGroup]="form">
        <div>
            <lib-alert-banner [alertType]="'error'"
                              [hidden]="!showDuplicateNameAlert"
                              [maxWidth]="'100%'"
                              [message]="this.duplicateGroupNameAlertMessage"></lib-alert-banner>
        </div>
        <div>
            <lib-alert-banner [alertType]="'error'"
                              [hidden]="!showDuplicateAliasAlert"
                              [maxWidth]="'100%'"
                              [message]="this.duplicateAliasAlert"></lib-alert-banner>
        </div>
        <div>
            <lib-alert-banner [alertType]="'error'"
                              [hidden]="!showOrganizationUsedAlert"
                              [maxWidth]="'100%'"
                              [message]="this.organizationUsedAlertMessage"></lib-alert-banner>
        </div>
        <div>
            <lib-alert-banner [alertType]="'error'"
                              [hidden]="!updateInactiveGroupAlertMessage.length"
                              [maxWidth]="'100%'"
                              [message]="this.updateInactiveGroupAlertMessage"></lib-alert-banner>
        </div>
        <div class="row mb-3">
            <div class="col-sm-9">
                <label for="groupName" class="form-label mm-label">Group Name<span
                    class="text-danger"> * </span></label>
                <input #groupNameInput type="text" class="form-control rounded-0 mb-2" id="groupName"
                       formControlName="groupName" required
                       [readOnly]="isGroupInactive ? 'readonly' : null"
                       [ngClass]="{'is-invalid': groupName?.invalid && (groupName?.dirty || groupName?.touched) || showDuplicateNameAlert, 'readonly': isGroupInactive}">
            </div>
            <div class="col-sm-3">
                <label for="groupStatus" class="form-label mm-label">Status</label>
                <fieldset id="groupStatus" class="mm-label pt-1">
                    <label class="radio-inline">
                        <input type="radio" formControlName="groupStatus" name="groupStatus" [value]="true"> Active
                    </label>
                    <label class="radio-inline p-lg-2">
                        <input type="radio" formControlName="groupStatus" name="groupStatus" [value]="false"> Inactive
                    </label>
                </fieldset>
            </div>
            <div *ngIf="groupName?.invalid && (groupName?.dirty || groupName?.touched)">
                <div *ngIf="groupName?.hasError('required')" class="text-danger">
                    Group Name is required.
                </div>
                <div *ngIf="groupName?.hasError('maxLength')" class="text-danger">
                    Group Name can not be longer than 100 characters.
                </div>
                <div *ngIf="groupName?.hasError('pattern')" class="text-danger">
                    Group Name is not valid.
                </div>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-sm-5">
                <label for="alias" class="form-label mm-label">
                    Organization Admin URL
                    <span *ngIf="!editedGroupId" class="text-danger"> * </span>
                </label>
                <div class="d-flex align-items-center">
                    <ng-container *ngIf="!editedGroupId; else editedGroupAlias">
                        <input #aliasInput type="text"
                               class="form-control rounded-0 mb-2"
                               id="alias"
                               formControlName="alias" required
                               [readOnly]="isGroupInactive ? 'readonly' : null"
                               [ngClass]="{
                            'is-invalid': alias?.invalid && (alias?.dirty || alias?.touched) || showDuplicateAliasAlert,
                            'readonly': isGroupInactive
                        }">
                    </ng-container>
                    <ng-template #editedGroupAlias>
                        <span class="text-nowrap">{{ aliasStr }}{{ orgAdminDomainStr }}</span>
                    </ng-template>
                </div>
            </div>
            <ng-container
                *ngIf="alias?.invalid && (alias?.dirty || alias?.touched)">
                <div class="text-danger">
                    <div *ngIf="alias?.hasError('required')">
                        Organization Admin URL is required.
                    </div>
                    <div *ngIf="alias?.hasError('maxLength')">
                        Organization Admin URL cannot be longer than 50 characters.
                    </div>
                    <div *ngIf="alias?.hasError('pattern')">
                        Organization Admin URL is not valid.
                    </div>
                </div>
            </ng-container>
        </div>
        <div class="card">
            <div class="card-header mm-card-header">
                Instances
            </div>
            <div class="card-body col-md-12">
                <div class="row mb-3">
                    <div class="col-md-12">
                        <mmoga-organization-search id="organization"
                                                   (newOrganizationSelectedEvent)="addOrganization($event)"
                                                   [selectedOrganizations]="groupOrganizations"
                                                   [readOnly]="isGroupInactive ? true : false">
                        </mmoga-organization-search>
                    </div>
                </div>
                <div class="mb-3 row">
                    <div class="col-md-5 mm-label text-start">Instances</div>
                    <div class="col-md-2 mm-label text-start">FGI
                        <span class="tooltip-icon" data-bs-toggle="tooltip" data-bs-placement="top"
                              title="Firm Global Identifier">
                            <fa-icon icon="info-circle"></fa-icon>
                        </span>
                    </div>
                    <div class="col-md-3 mm-label text-start">Confirmation Status</div>
                    <div class="col-md-1 mm-label text-start">Actions</div>
                </div>
                <div *ngIf="!hasOrganizationsAdded()" class="mb-3">No Instances Added</div>
                <div *ngIf="hasOrganizationsAdded()">
                    <div class="mb-3 row" *ngFor="let member of enterpriseMemberships">
                        <div class="col-md-5 text-start">{{member?.organization?.urlHost}}</div>
                        <div class="col-md-2 text-start">{{member?.organization?.globalIdentifier}}</div>
                        <div class="col-md-3 text-start">
	                        <ng-container *ngIf="isRelocationInConfirmation(member?.organization!.id); else showFormattedStatus">
		                        {{ getRelocationConfirmationMessage(member?.organization!.id) }}
	                        </ng-container>
	                        <ng-template #showFormattedStatus>
		                        {{ member | formatInstanceStatus }}
	                        </ng-template>
                        </div>
                        <div class="col-md-1 text-start">
                            <ng-container
                                    *ngIf="isRelocationNotRejected(member?.organization!.id); else allowMove">
                                <span data-identifier="organization-relocation-moving" class="readonly bg-transparent">
                                    {{ getRelocationStatusMessage(member?.organization!.id) }}
                                </span>
                            </ng-container>
                            <ng-template #allowMove>
                                <button data-identifier="organization-relocation-open"
                                        class="btn btn-link text-decoration-none"
                                        [disabled]="isMoveDisabled(member)"
                                        (click)="moveOrganization(member.organization)">Move
                                </button>
                            </ng-template>
                        </div>
                    </div>
                </div>
                <div *ngIf="hasOrganizationsAdded()" class="pagination-count d-flex align-items-center">
                    <span class="me-1">Total Records: </span>
                    <span class="fw-bold">{{ enterpriseMemberships.length }}</span>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="mt-3 rounded-0">
    <button type="button" class="btn btn-sm btn-default me-2" (click)="cancel()">Cancel</button>
    <button type="submit" class="btn btn-sm btn-primary" (click)="save()" [disabled]="!form.valid">Save</button>
</div>
